import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { datadogLogs } from '@datadog/browser-logs';
import { TranslocoHttpLoader } from '@jump-tech-frontend/app-config';
import {
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  TRANSLOCO_MISSING_HANDLER,
  translocoConfig,
  TranslocoLoader,
  TranslocoMissingHandler,
  TranslocoMissingHandlerData,
  TranslocoModule
} from '@ngneat/transloco';
import { environment } from '../environments/environment';

const DEFAULT_FALLBACK_LANG = 'en-GB';

@Injectable({ providedIn: 'root' })
export class RelayTranslationsLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  /**
   * Fetches the translation file from the existing API endpoint.
   * @param lang
   */
  async getTranslation(lang: string) {
    const data = await new TranslocoHttpLoader(this.http, environment.name).getTranslation(lang, 'relay');
    if (data) {
      // save off the active i18ns to session storage, so we can then consume in core components
      sessionStorage.setItem(`activeI18ns`, JSON.stringify(data));
    }
    return data;
  }
}

@Injectable()
export class TranslocoMissingKeyHandler implements TranslocoMissingHandler {
  handle(key: string, config: TranslocoMissingHandlerData) {
    datadogLogs.logger.error(`i18n: Missing translation for key: ${key} in language file: ${config['activLang']}`, {
      key,
      lang: config['activeLang']
    });
    return key;
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: ['en'],
        defaultLang: 'en',
        fallbackLang: [DEFAULT_FALLBACK_LANG],
        reRenderOnLangChange: true,
        failedRetries: 1,
        prodMode: environment.production,
        missingHandler: {
          useFallbackTranslation: true
        }
      })
    },
    { provide: TRANSLOCO_LOADER, useClass: RelayTranslationsLoader },
    {
      provide: TRANSLOCO_MISSING_HANDLER,
      useClass: TranslocoMissingKeyHandler
    }
  ]
})
export class TranslocoRootModule {}
